import React, { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './Layout.module.css';
import BreakLine from '../commons/break-line';
import NavigationFooter from '../navigation-footer';
import ButtonAction from '../../interfaces/buttonAction';

interface LayoutProps {
  children: React.ReactNode;
  backButton: ButtonAction;
  nextButton: ButtonAction;
}

const Layout: ForwardRefExoticComponent<
  PropsWithoutRef<LayoutProps> & RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, LayoutProps>(({ children, backButton, nextButton }, ref) => (
  <>
    <div ref={ref} className={styles.appContainer}>
      <BreakLine />
      {children}
      <NavigationFooter backButton={backButton} nextButton={nextButton} />
    </div>
  </>
));

Layout.displayName = 'Layout';

export default Layout;
